// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
  background: white;
  max-width: 360px;
  margin: 100px auto 16px;
  padding: 32px 24px 16px;
  border-radius: 3px;
}

.message h3 {
  color: #888;
  font-weight: normal;
  font-size: 16px;
  margin: 16px 0 12px;
}

.message h2 {
  color: #d32f2f;
  font-weight: bold;
  font-size: 16px;
  margin: 0 0 8px;
}

.message h1 {
  font-size: 22px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.6);
  margin: 0 0 16px;
}

.message p {
  line-height: 140%;
  margin: 16px 0 24px;
  font-size: 14px;
}

.message a {
  display: block;
  text-align: center;
  background: #d32f2f;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  padding: 7px;
  border-radius: 4px;
}

.message,
.message a {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

#load {
  color: rgba(0, 0, 0, 0.4);
  text-align: center;
  font-size: 13px;
}

@media (max-width: 600px) {
  body,
  .message {
    margin-top: 0;
    background: white;
    box-shadow: none;
  }
  body {
    border-top: 16px solid #d32f2f;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/UnAuthorized/Unauthorized.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;IAEE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".message {\n  background: white;\n  max-width: 360px;\n  margin: 100px auto 16px;\n  padding: 32px 24px 16px;\n  border-radius: 3px;\n}\n\n.message h3 {\n  color: #888;\n  font-weight: normal;\n  font-size: 16px;\n  margin: 16px 0 12px;\n}\n\n.message h2 {\n  color: #d32f2f;\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0 0 8px;\n}\n\n.message h1 {\n  font-size: 22px;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.6);\n  margin: 0 0 16px;\n}\n\n.message p {\n  line-height: 140%;\n  margin: 16px 0 24px;\n  font-size: 14px;\n}\n\n.message a {\n  display: block;\n  text-align: center;\n  background: #d32f2f;\n  text-transform: uppercase;\n  text-decoration: none;\n  color: white;\n  padding: 7px;\n  border-radius: 4px;\n}\n\n.message,\n.message a {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n#load {\n  color: rgba(0, 0, 0, 0.4);\n  text-align: center;\n  font-size: 13px;\n}\n\n@media (max-width: 600px) {\n  body,\n  .message {\n    margin-top: 0;\n    background: white;\n    box-shadow: none;\n  }\n  body {\n    border-top: 16px solid #d32f2f;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
